import type { Unit } from './types';

export const isNumber = (n: Unit): n is number =>
  typeof n === 'number' && !isNaN(n);

export const px = (n: Unit): string => (isNumber(n) ? n + 'px' : n);
